import { BaseIcon, BaseIconProps } from './BaseIcon';

export const RssGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="rssGrad" {...props}>
    <path d="M4 11a9 9 0 0 1 9 9M4 4a16 16 0 0 1 16 16" stroke="url(#rssGrad)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    <circle cx="5" cy="19" r="1" fill="url(#rssGrad)" />
  </BaseIcon>
);
